export interface IDeductionCount {
  all: number;
  incomplete: number;
  stages: IDeductionCountStage[];
}

export interface IDeductionCountStage {
  stageId: number;
  count: number;
}

export class DeductionCountStage implements IDeductionCountStage {
  private readonly _stageId: number;
  private readonly _count: number;

  constructor(props: IDeductionCountStage) {
    this._stageId = props.stageId;
    this._count = props.count;
  }

  get stageId(): number {
    return this._stageId;
  }

  get count(): number {
    return this._count;
  }
}

export class DeductionCount implements IDeductionCount {
  private readonly _all: number;
  private readonly _incomplete: number;
  private readonly _stages: IDeductionCountStage[];

  constructor(props: IDeductionCount) {
    this._all = props.all;
    this._incomplete = props.incomplete;
    this._stages = props.stages;
  }

  get all(): number {
    return this._all;
  }

  get incomplete(): number {
    return this._incomplete;
  }

  get stages(): {
    stageId: number;
    count: number;
  }[] {
    return this._stages;
  }

  getStageById(stageId: number): IDeductionCountStage | undefined {
    return this._stages.find(stage => stage.stageId === stageId);
  }
}
